
<!-- <nb-layout withScroll="false"> -->
    <!-- <nb-sidebar class="settings-sidebar" tag="component-right" state="collapsed" right>
        <ubs-settings-container [settings]="componentConfig.settings"  [state]="state$"></ubs-settings-container>
    </nb-sidebar> -->
    <nb-layout-column class="component-layout-column" #mainCard>
        <!-- <ubs-settings-container [settings]="componentConfig.settings"  [state]="state$"></ubs-settings-container> -->
        <div class="row">
            <ng-container *ngIf="state$ | async as state"> 
                <div class="col-md-12">
                    <nb-card class="component-card" *ngIf="!isSideBarOpen">
                        <nb-card-header *ngIf="!isStandAlone">
                            <ubs-header-container 
                                [state] = "state$"
                                (setTopList)="setList($event)">
                            </ubs-header-container>
                        </nb-card-header>
                        <nb-card-body style="padding:0">
                            <div [ngSwitch]="action">
                                <span *ngSwitchCase="'list'">
                                    <ubs-list-container [state]="state$" [listForms]="listForms" [addForms]="addForms" [incomingLink]="incomingLink"></ubs-list-container>
                                </span>
                                <span *ngSwitchCase="'find'"><ubs-find-container></ubs-find-container></span>
                                <span *ngSwitchCase="'add'"><ubs-add-container [state]="state$" [activeLevel]="activeLevel" [addForms]="addForms" [action]="action"></ubs-add-container></span>
                                <span *ngSwitchCase="'delete'"><ubs-edit-container></ubs-edit-container></span>
                                <span *ngSwitchCase="'edit'">
                                    <ubs-edit-container [state]="state$" [activeLevel]="activeLevel" [addForms]="addForms" [action]="action" [relations]="relations"></ubs-edit-container>
                                </span>
                                <span *ngSwitchCase="'view'"><ubs-view-container></ubs-view-container></span>
                                <span *ngSwitchCase="'relate'"><ubs-relation-container [relation]="relation" [relations]="relations" [selectedValue]="selectedValue"></ubs-relation-container></span>
                                <span *ngSwitchCase="'master-detail'">
                                    <ubs-master-detail-container [masterDetail]="selectedMasterDetail" [state]="state$" [listForms]="listForms" [addForms]="addForms" [incomingLink]="incomingLink"></ubs-master-detail-container>
                                </span>
                                <span *ngSwitchCase="'custom'">
                                    <ubs-custom-container></ubs-custom-container>
                                </span>
                                <span *ngSwitchCase="'tasks-action-result'">
                                    <ubs-task-container></ubs-task-container>
                                </span>
                            </div>
                        </nb-card-body>
                        <!-- <ubs-sidebar-toggle-button (toggleSidebar)="toggleSidebar($event)"></ubs-sidebar-toggle-button> -->
                    </nb-card>
                    <ubs-sidebar-toggle-button *ngIf="showAssistantButton" (toggleSidebar)="toggleSidebar($event)" [isSideBarOpen]="isSideBarOpen"></ubs-sidebar-toggle-button>
                </div>
            </ng-container>
        </div>
    </nb-layout-column>
<!-- </nb-layout> -->

<!-- <nb-layout-column>
    <nb-layout withScroll="false">
        <nb-sidebar class="settings-sidebar" tag="component-right" state="collapsed" right>
            <ubs-settings-container [settings]="componentConfig.settings"  [state]="state$"></ubs-settings-container>
        </nb-sidebar>
        <nb-layout-column class="component-layout-column">
        <div class="row">
            <ng-container *ngIf="state$ | async as state"> 
                <div class="col-md-12">
                    <nb-card>
                        <nb-card-header>
                            <ubs-header-container 
                                [state] = "state$"
                                (setTopList)="setList($event)">
                            </ubs-header-container>
                        </nb-card-header>
                        <nb-card-body style="padding:0">
                            
                            <div [ngSwitch]="action">
                                <span *ngSwitchCase="'list'">
                                    <ubs-list-container [state]="state$"></ubs-list-container>
                                </span>
                                <span *ngSwitchCase="'find'"><ubs-find-container></ubs-find-container></span>
                                <span *ngSwitchCase="'add'"><ubs-add-container [activeLevel]="activeLevel" [addForms]="addForms"></ubs-add-container></span>
                                <span *ngSwitchCase="'delete'"><ubs-edit-container></ubs-edit-container></span>
                                <span *ngSwitchCase="'edit'"><ubs-edit-container [activeLevel]="activeLevel" [addForms]="addForms"></ubs-edit-container></span>
                                <span *ngSwitchCase="'view'"><ubs-view-container></ubs-view-container></span>
                            </div>
                        </nb-card-body>
                    </nb-card>
                </div>
            </ng-container>
        </div>
        </nb-layout-column>
    </nb-layout>
</nb-layout-column> -->



